import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SignUpButton from '../../layout/navbar/sign-up-button';

const Container = styled.div`
  background-color: #1E2737;
  height: 480px;
  width: 100%;
`;

const InnerContainer = styled.div`
  display: flex;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 480px;
  width: 50%;

  ${props => props.theme.isLarge && `
    padding-left: 7.5%;
  `};

  ${props => props.theme.isXLarge && `
    padding-left: calc(50% - 476px);
  `};

  ${props => props.theme.isXXLarge && `
    padding-left: calc(50% - 600px);
  `};
`;

const Right = styled.div`
  width: 50%;
  padding-left: 64px;
`;

const Img = styled.img`
  height: 480px;
  max-height: 480px;
  width: 100%;
  object-fit: cover;
`;

const Headline = styled.div`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 40px;
  line-height: 120%;
  text-transform: none;
  margin-bottom: 16px;
`;

const Byline = styled.div`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  font-size: 19px;
  line-height: 130%;
  text-transform: none;
`;

const ButtonContainer = styled.div`
  margin-top: 40px;
  width: 100%;
`;

const Link = styled.a`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 34px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-left: 20px;
  vertical-align: bottom;

  &:hover {
    color: ${props => props.theme.bodyBackgroundColor};
    cursor: pointer;
  }
`;

export default function Desktop({ banner, signUpUrl, signInUrl }) {
  const {
    imageUrl,
    headline,
    byline,
    registerButtonCopy,
  } = banner;

  return (
    <Container>
      <InnerContainer>
        <Left>
          <Headline>{headline}</Headline>
          <Byline>{byline}</Byline>
          <ButtonContainer>
            <SignUpButton label={registerButtonCopy} signUpUrl={signUpUrl} />
            <Link href={signInUrl}>Sign In</Link>
          </ButtonContainer>
        </Left>
        <Right>
          <Img src={imageUrl} />
        </Right>
      </InnerContainer>
    </Container>
  );
}

Desktop.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    headline: PropTypes.string.isRequired,
    byline: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    registerButtonCopy: PropTypes.string,
  }).isRequired,
  signUpUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
};
